import DOMPurify from "dompurify";

const htmlToPlainText = (html?: string) => {
  if (!html) return "";

  // ล้าง tag/attribute ทั้งหมด แต่คง text ไว้
  const text = DOMPurify.sanitize(html, { ALLOWED_TAGS: [], ALLOWED_ATTR: [] });

  // normalize spacing
  return text
    .replace(/\u00A0/g, " ")   // &nbsp; -> space
    .replace(/\s+\n/g, "\n")
    .replace(/\n+/g, " ")
    .replace(/\s{2,}/g, " ")
    .trim();
};

export default htmlToPlainText;